/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { TransferListItem } from "./TransferListItem";
import * as t from "io-ts";

/**
 * Payment notice data
 */

// required attributes
const PaymentNoticeR = t.interface({
  paymentAmount: t.Integer,

  primaryCreditorInstitution: t.string,

  transferList: t.readonlyArray(TransferListItem, "array of TransferListItem")
});

// optional attributes
const PaymentNoticeO = t.partial({});

export const PaymentNotice = t.intersection(
  [PaymentNoticeR, PaymentNoticeO],
  "PaymentNotice"
);

export type PaymentNotice = t.TypeOf<typeof PaymentNotice>;
